import { gate } from 'hub-http/gates';
import { hasGate, hasScope } from 'personalization-lib/utils/auth/userPermissions';
export const getFeatureGates = () => ({
  webVisitors: hasGate(gate('CRM:Segments:WebVisitors')),
  websitePages: hasGate(gate('Personalize:WebsitePages')),
  imageGenInput: hasGate(gate('Personalize:GenerateImagesInput')),
  newNav: hasGate(gate('Personalize:NavRevamp')),
  createVariantInEditor: hasGate(gate('Personalize:CreateVariantInEditor')),
  ctaV2Editor: hasGate(gate('WebInteractives:ScalableEditor')),
  agentSunset: hasGate(gate('Personalize:AgentSunset'))
});
export const getPersonalizationAccess = () => ({
  view: hasScope('personalize-view'),
  edit: hasScope('personalize-edit')
});